import { render } from '@xingternal/hops';
import React from 'react';

import { Application } from './src/Application';
import { reducers, actionCreators } from './src/redux';

export default render(<Application />, {
  redux: {
    reducers,
    actionCreators,
  },
});
